function customizeJudgeme() {
  console.log('Customize judgeme');
  // remove ( and ) from tabs
  document.querySelectorAll('.jdgm-subtab__name').forEach(el => {
    el.innerHTML = el.innerHTML.replace(/\((.*?)\)/g, '$1');
  });

  // move the search input 
  const searchWrapper = document.querySelector(".jdgm-review-search-wrapper");
  const sortWrapper = document.querySelector(".jdgm-rev-widg__sort-wrapper");
  if (searchWrapper && sortWrapper) {
    sortWrapper.parentNode.insertBefore(searchWrapper, sortWrapper);
  }
}
document.addEventListener("DOMContentLoaded", () => {
  const jdgmRevWidg = document.querySelector('.jdgm-rev-widg');
  const config = { childList: true, subtree: true };
  const observer = new MutationObserver((mutationsList, observer) => {
    for (const mutation of mutationsList) {
      for (const node of mutation.addedNodes) {

        if(jdgmRevWidg.querySelector(".jdgm-review-search")){
          customizeJudgeme();
          observer.disconnect();
        }
      }
    }
  });
  if(!document.body.classList.contains("page-secret-batch-lp")){
    observer.observe(jdgmRevWidg, config);
  }
    
  

  //setTimeout(customizeJudgeme, 5000);
});


/* Adjust the input for variant picker to prevent scroll-up. ONLY On product pages*/ 
const productTitle = document.querySelector(".product .product__title");
if (productTitle){  
  const customVariantPriceWrapper = document.querySelector(".custom-variant-price-wrapper");  
  if(customVariantPriceWrapper){
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {        
          customVariantPriceWrapper.classList.remove("push-down");
        } else {        
          customVariantPriceWrapper.classList.add("push-down");
        }
      });
    }, {
      root: null,          // viewport
      threshold: 0         // se dispara apenas un píxel entra o sale
    });
    observer.observe(productTitle); 
  }
  

  
}